<template>
    <article class="idea-item">
        <div class="idea-item__header">
            <h3 class="idea-item__title">{{ idea.title }}</h3>
            <slot name="actions" />
        </div>
        <PexelImages
            v-if="idea.pexel_images?.length"
            class="idea-item__images"
            :images="idea.pexel_images"
        />
        <div v-if="hasBadges" class="idea-item__meta">
            <span v-if="idea.budget_level" class="idea-item__badge">
                {{ $enumGet("travel_style", idea.budget_level) }}
            </span>
            <span v-if="idea.pace" class="idea-item__badge">
                {{ $enumGet("travel_pace", idea.pace) }}
            </span>
            <span v-if="idea.connection_mode" class="idea-item__badge">
                <span class="material-symbols-outlined">{{
                    $iconGet("transport", idea.connection_mode)
                }}</span>
                <template v-if="idea.connection_hours"
                    >~{{ idea.connection_hours }}h</template
                >
            </span>
            <span
                v-for="theme in idea.themes || []"
                :key="theme"
                class="idea-item__badge idea-item__badge--theme"
            >
                {{ $enumGet("travel_theme", theme) }}
            </span>
        </div>
        <div class="idea-item__body">
            <p><strong>Summary</strong>: {{ idea.summary }}</p>
            <p><strong>Why it fits</strong>: {{ idea.why_it_fits }}</p>
            <p>
                <strong>{{
                    countries.length > 1 ? "Countries" : "Country"
                }}</strong
                >: {{ countries.join(" • ") }}
            </p>
            <p>
                <strong>{{
                    idea.locations.length > 1 ? "Locations" : "Location"
                }}</strong
                >: {{ locations.join(" • ") }}
            </p>
            <p><strong>Highlights</strong>:</p>
            <ol>
                <li v-for="highlight in idea.highlights" :key="highlight">
                    {{ highlight }}
                </li>
            </ol>
        </div>
        <slot />
    </article>
</template>

<script>
import PexelImages from "js/components/common/PexelImages.vue";

export default {
    name: "IdeaItem",
    components: { PexelImages },
    props: {
        idea: { type: Object, required: true },
    },
    computed: {
        hasBadges() {
            const { budget_level, pace, connection_mode, themes } = this.idea;
            return !!(
                budget_level ||
                pace ||
                connection_mode ||
                themes?.length
            );
        },
        countries() {
            return this.idea.country_names ?? this.idea.countries ?? [];
        },
        locations() {
            return this.idea.locations.map((loc) => loc.split(",")[0].trim());
        },
    },
};
</script>
